import React from "react";
import { Box, Typography } from "@mui/material";
import {
  ArrowForwardRounded,
  AutoAwesomeRounded,
  TrendingUpRounded,
} from "@mui/icons-material";

import badgeStar1 from "../../resources/images/png/home/reasons5/badge-star-1.svg";
import badgeStar2 from "../../resources/images/png/home/reasons5/badge-star-2.svg";
import badgeStar3 from "../../resources/images/png/home/reasons5/badge-star-3.svg";
import backgroundGroup from "../../resources/images/png/home/reasons5/background-group.svg";
import backgroundRectangle from "../../resources/images/png/home/reasons5/background-rectangle.svg";
import backgroundZoom from "../../resources/images/png/home/reasons5/background-zoom.svg";
import cardIcon1 from "../../resources/images/png/home/reasons5/card-icon-1.png";
import cardIcon2 from "../../resources/images/png/home/reasons5/card-icon-2.png";
import cardIcon3 from "../../resources/images/png/home/reasons5/card-icon-3.png";
import cardIcon4 from "../../resources/images/png/home/reasons5/card-icon-4.png";
import cardIcon5 from "../../resources/images/png/home/reasons5/card-icon-5.png";

const reasons = [
  {
    number: "1",
    title: "Gagnez en visibilité... et en crédibilité",
    description:
      "De nombreux praticiens de qualité peinent à être visibles ou à inspirer confiance auprès de personnes qui ne les connaissent pas encore...",
    detail:
      "Bénéficiez d’une présence dans l’annuaire Inexploré pour valoriser votre activité dans un cadre de confiance, auprès d’un public déjà sensibilisé aux approches intégratives et à la connaissance de soi.",
    borderColor: "#F1C555",
    glowColor: "rgba(247, 225, 68, 0.42)",
    accentColor: "#F1C555",
    iconImage: cardIcon1,
  },
  {
    number: "2",
    title: "Participez au laboratoire interdisciplinaire",
    description:
      "Face à certains enjeux multidimensionnels, il est parfois difficile de trouver seul les bonnes clés de compréhension ou les bons relais...",
    detail:
      "Intégrez un groupe de réflexion entre praticiens pour mieux comprendre les situations complexes et accéder à une cartographie d'alliés sur lesquels vous appuyer.",
    borderColor: "#0596A1",
    glowColor: "rgba(5, 150, 161, 0.52)",
    accentColor: "#0596A1",
    iconImage: cardIcon2,
    concretelyLabel: "Concrètement ? Et si vous le souhaitez",
  },
  {
    number: "3",
    title: "Créez des séances collectives",
    description:
      "Les consultations individuelles ont un impact précieux... mais elles limitent naturellement le nombre de personnes que vous pouvez accompagner.",
    detail:
      "Organisez des événements sur notre plateforme autour de rituels ou d'expériences partagées, pour avoir plus d’impact et toucher davantage de monde.",
    borderColor: "#9A45F4",
    glowColor: "rgba(154, 69, 244, 0.52)",
    accentColor: "#9A45F4",
    iconImage: cardIcon3,
    concretelyLabel: "Concrètement ? Et si vous le souhaitez",
  },
  {
    number: "4",
    title: "Libérez-vous des tâches administratives",
    description:
      "Trop de praticiens consacrent une énergie précieuse à l'organisation, à l'administratif et à la gestion des imprévus.",
    detail:
      "Accédez à des outils et services conçus pour fluidifier vos rendez-vous, sécuriser vos paiements, gérer les cas particuliers et vous libérer de nombreuses charges au quotidien.",
    borderColor: "#FF4626",
    glowColor: "rgba(252, 125, 6, 0.42)",
    accentColor: "#FC7D06",
    iconImage: cardIcon4,
    concretelyLabel: "Concrètement ? Et si vous le souhaitez",
  },
  {
    number: "5",
    title: "Bénéficiez d'un accompagnement stratégique",
    description:
      "Avoir du talent ne garantit pas d'être compris, reconnu ou choisi par les personnes que l'on pourrait réellement aider...",
    detail:
      "Participez à des programmes de communication et de réussite, dédiés au développement de votre positionnement, de votre visibilité et de votre activité.",
    borderColor: "#1E73FF",
    glowColor: "rgba(30, 115, 255, 0.42)",
    accentColor: "#3971F6",
    iconImage: cardIcon5,
  },
];

const cardLayout = [
  { xs: "1 / -1", md: "span 6", xl: "span 6" },
  { xs: "1 / -1", md: "span 6", xl: "span 6" },
  { xs: "1 / -1", md: "span 6", xl: "span 6" },
  { xs: "1 / -1", md: "span 6", xl: "span 6" },
  { xs: "1 / -1", md: "4 / span 6", xl: "4 / span 6" },
];

const numberSx = {
  fontFamily: "Branding Bold !important",
  fontSize: { xs: "92px", sm: "120px", lg: "174px" },
  lineHeight: 0.88,
  letterSpacing: "-0.04em",
  background:
    "linear-gradient(180deg, rgba(255,255,255,0.18) 25.77%, rgba(255,255,255,0.05) 95.73%)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
};

const Reasons5 = () => {
  const [yearLanding, setYearLanding] = React.useState((new Date().getFullYear()));

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        pt: { xs: 8, md: 12, xl: "160px" },
        pb: { xs: 8, md: 12, xl: "120px" },
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(180deg, rgba(13,0,52,0.02) 0%, rgba(13,0,52,0) 100%)",
          pointerEvents: "none",
        }}
      />
      <Box
        component="img"
        src={backgroundGroup}
        alt=""
        sx={{
          position: "absolute",
          top: { xs: -112, md: -90, xl: -72 },
          left: "50%",
          transform: "translateX(-50%)",
          width: { xs: 520, md: 760, xl: 942 },
          maxWidth: "72vw",
          opacity: 0.9,
          pointerEvents: "none",
        }}
      />
      {/*<Box
        component="img"
        src={backgroundRectangle}
        alt=""
        sx={{
          position: "absolute",
          top: { xs: 320, md: 390, xl: 458 },
          left: "50%",
          transform: "translateX(-50%)",
          width: { xs: "178%", md: "126%", xl: 1439 },
          maxWidth: "none",
          opacity: 0.95,
          pointerEvents: "none",
        }}
      />*/}
      <Box
        sx={{
          position: "absolute",
          left: { xs: "-10%", md: "2%", xl: "5%" },
          bottom: { xs: 110, md: 90, xl: 70 },
          width: { xs: 220, md: 320, xl: 380 },
          height: { xs: 220, md: 320, xl: 380 },
          background:
            "radial-gradient(circle, rgba(57,113,246,0.48) 0%, rgba(57,113,246,0.16) 42%, rgba(57,113,246,0) 74%)",
          filter: "blur(34px)",
          opacity: 0.85,
          pointerEvents: "none",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          right: { xs: "-8%", md: "2%", xl: "6%" },
          bottom: { xs: 110, md: 80, xl: 58 },
          width: { xs: 220, md: 320, xl: 390 },
          height: { xs: 220, md: 320, xl: 390 },
          background:
            "radial-gradient(circle, rgba(247,225,68,0.42) 0%, rgba(252,125,6,0.2) 40%, rgba(252,125,6,0) 74%)",
          filter: "blur(34px)",
          opacity: 0.82,
          pointerEvents: "none",
        }}
      />

      <Box
        sx={{
          position: "relative",
          zIndex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
        }}
      >
        <Typography
          variant="h2"
          sx={{
            color: "white",
            textAlign: "center",
            fontSize: { xs: "28px", md: "32px", xl: "35px" },
            px: 2,
          }}
        >
          Les 5 bonnes raisons d&apos;être labellisé
        </Typography>

        <Box
          sx={{
            position: "relative",
            width: { xs: "124px", md: "154px", xl: "180px" },
            aspectRatio: "173.226 / 177.246",
            mb: { xs: 5, md: 4, xl: 6 },
          }}
        >
          <Box
            component="img"
            src={badgeStar1}
            alt=""
            sx={{
              position: "absolute",
              inset: 0,
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
          />
          <Box
            component="img"
            src={badgeStar3}
            alt=""
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              width: "89.7%",
              height: "89.7%",
              transform: "translate(-50%, -50%)",
              objectFit: "contain",
            }}
          />
          <Box
            component="img"
            src={badgeStar2}
            alt=""
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              width: "83.5%",
              height: "83.5%",
              transform: "translate(-50%, -50%)",
              objectFit: "contain",
            }}
          />
          <Typography
            sx={{
              position: "absolute",
              top: "31%",
              left: "50%",
              transform: "translateX(-50%)",
              color: "#FBF0E5",
              fontFamily: "YesevaOne !important",
              fontSize: { xs: "24px", md: "28px", xl: "35px" },
              lineHeight: 1,
            }}
          >
            Label
          </Typography>
          <Typography
            sx={{
              position: "absolute",
              top: "54%",
              left: "50%",
              transform: "translateX(-50%)",
              color: "#FBF0E5",
              fontFamily: "YesevaOne !important",
              fontSize: { xs: "20px", md: "23px", xl: "29px" },
              lineHeight: 1,
            }}
          >
            {yearLanding}
          </Typography>
        </Box>

        <Box
          sx={{
            width: "90%",
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              md: "repeat(12, minmax(0, 1fr))",
            },
            gap: { xs: 8, md: 9, xl: 8 },
          }}
        >
          {reasons.map((reason, index) => (
            <Box
              key={reason.number}
              sx={{
                gridColumn: cardLayout[index],
                position: "relative",
              }}
            >
              <Box
                sx={{
                  position: "absolute",
                  top: { xs: -42, md: -52, xl: -66 },
                  left: "50%",
                  transform: "translateX(-50%)",
                  width: { xs: 84, md: 108, xl: 132 },
                  height: { xs: 84, md: 108, xl: 132 },
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background:
                    "radial-gradient(circle at 35% 30%, rgba(255,255,255,0.3), rgba(255,255,255,0) 24%), radial-gradient(circle at 50% 50%, rgba(154,69,244,0.85), rgba(55,18,101,0.96) 68%)",
                  boxShadow: `0 20px 50px ${reason.glowColor}`,
                  overflow: "hidden",
                  zIndex: 2,
                }}
              >
                {reason.iconImage ? (
                  <Box
                    component="img"
                    src={reason.iconImage}
                    alt=""
                    sx={{ width: "100%", height: "100%", objectFit: "cover" }}
                  />
                ) : (
                  <Box
                    sx={{
                      width: "78%",
                      height: "78%",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      background:
                        "radial-gradient(circle, rgba(255,255,255,0.14) 0%, rgba(255,255,255,0.04) 60%, rgba(255,255,255,0) 100%)",
                    }}
                  >
                    {reason.renderSymbol?.()}
                  </Box>
                )}
              </Box>

              <Box
                sx={{
                  minHeight: { xs: "auto", xl: 442 },
                  background: "rgba(13, 0, 52, 0.32)",
                  border: `1.5px solid ${reason.borderColor}`,
                  borderRadius: "20px",
                  boxShadow: `0 4px 99.3px ${reason.glowColor}`,
                  px: { xs: 2.5, md: 3 },
                  pt: { xs: 6.5, md: 8, xl: 10.5 },
                  pb: 3,
                  display: "flex",
                  flexDirection: "column",
                  gap: 1.75,
                  backdropFilter: "blur(2px)",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                  }}
                >
                  <Typography sx={numberSx}>{reason.number}</Typography>
                  <Box sx={{ minWidth: 0 }}>
                    <Typography
                      sx={{
                        color: "white",
                        fontFamily: "Branding Bold !important",
                        fontSize: { xs: "24px", md: "26px", xl: "30px" },
                        lineHeight: 1.08,
                        mb: 1.25,
                      }}
                    >
                      {reason.title}
                    </Typography>
                    <Typography
                      sx={{
                        color: "rgba(255,255,255,0.62)",
                        fontSize: "16px",
                        lineHeight: 1.35,
                      }}
                    >
                      {reason.description}
                    </Typography>
                  </Box>
                </Box>

                <Typography
                  sx={{
                    color: "rgba(255,255,255,0.5)",
                    fontSize: "15px",
                    fontFamily: "Branding Bold !important",
                    textTransform: "uppercase",
                    letterSpacing: "0.115em",
                    mt: 0.5,
                  }}
                >
                  {reason.concretelyLabel || "Concrètement ?"}
                </Typography>

                <Box
                  sx={{
                    width: "100%",
                    height: "1px",
                    background:
                      "linear-gradient(90deg, rgba(255,255,255,0.7) 0%, rgba(255,255,255,0.18) 100%)",
                  }}
                />

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 1.75,
                  }}
                >
                  <Box
                    sx={{
                      mt: "2px",
                      width: 32,
                      height: 32,
                      minWidth: 32,
                      borderRadius: "50%",
                      backgroundColor: reason.accentColor,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <ArrowForwardRounded sx={{ color: "white", fontSize: 20 }} />
                  </Box>
                  <Typography
                    sx={{
                      color: "white",
                      fontSize: "16px",
                      lineHeight: 1.35,
                    }}
                  >
                    {reason.detail}
                  </Typography>
                </Box>
              </Box>
            </Box>
          ))}
        </Box>

        <Box
          sx={{
            width: "100%",
            maxWidth: { xs: "100%", md: "80%", xl: "86%" },
            mt: { xs: 4, md: 6, xl: 8 },
            position: "relative",
            display: "none"
          }}
        >
          <Box
            sx={{
              position: "absolute",
              inset: { xs: "-18px", md: "-24px", xl: "-27px" },
              borderRadius: { xs: "24px", md: "28px", xl: "32px" },
              opacity: 0.45,
              filter: "blur(56px)",
              background:
                "linear-gradient(118deg, #0596A1 3.64%, #3971F6 22.09%, #9A45F4 43.24%, #FC7D06 61.24%, #F7E144 79.24%, #FF4626 97.25%)",
              pointerEvents: "none",
            }}
          />

          <Box
            sx={{
              position: "relative",
              borderRadius: "20px",
              overflow: "hidden",
              minHeight: { xs: 240, sm: 320, md: 600, xl: 560 },
              backgroundColor: "#14003E",
              boxShadow: "0 22px 80px rgba(44, 59, 255, 0.2)",
            }}
          >
            <Box
              component="iframe"
              src="https://www.youtube-nocookie.com/embed/6gZgLgfSUhg?si=VjKARYCrNY7K8ht8"
              title="Video Inexplore Praticiens"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              sx={{
                position: "absolute",
                inset: 0,
                width: "100%",
                minHeight: 600,
                border: 0,
                display: "block",
              }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Reasons5;
